import React from 'react';

const ChangedContext = React.createContext();
export default ChangedContext;
